import React from 'react';
import AppConsentPie from './AppConsentPie';
import AppVendorConsent from './AppVendorConsent';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const ConsentTab = ({appId, filter}) => {
  const { t } = useTranslation();
  return (
    <Row>
      <Col>
        <AppVendorConsent appId={appId} filter={filter} />
      </Col>
      <Col>
        <AppConsentPie source={"active_devices"} title={t("publisher.consentAllDevices")} appId={appId} filter={filter}/>
      </Col>
      <Col>
        <AppConsentPie source={"location_authorized_devices"} title={t("publisher.location_authorized_devices")} appId={appId} filter={filter}/>
      </Col>
    </Row>
  )
}

export default ConsentTab